import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import { Link } from "react-router-dom";
import {
  deletePost,
  addLike,
  addView,
  removeLike,
} from "../../actions/postActions";
import isEmpty from "../../validation/is-empty";
import { Badge, Card, Col, Row } from "react-bootstrap";
import Moment from "react-moment";

class PostItem extends Component {
  onDeleteClick(id) {
    this.props.deletePost(id);
  }

  onLikeClick(id) {
    this.props.addLike(id);
  }

  onViewClick(id) {
    this.props.addView(id);
  }

  onUnlikeClick(id) {
    this.props.removeLike(id);
  }

  findUserLike(likes) {
    const { auth } = this.props;
    if (likes.filter((like) => like.user === auth.user.id).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  findUserView(views) {
    const { auth } = this.props;
    if (views.filter((view) => view.user === auth.user.id).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { post, auth, showActions } = this.props;
    console.log("post_view", post.views);

    return (
      <div className="card card-body mb-3 shadow-md shadow-lg shadow-sm p-lg-3 p-md-3">
        <div className="row">
          <div className="col-md-2 col-sm-2 bg-dark d-none d-lg-block text-info ">
            <a href="profile.html">
              <img
                className="rounded-circle d-none d-md-block"
                src={post.avatar}
                alt=""
              />
            </a>
            <br />
            <p className="text-center">
              <em> {post.name}</em>
            </p>
          </div>
          <div className="col-md-10">
            <Card>
              <Card.Header className="bg-info text-light">
                IciApart&rooms
              </Card.Header>
              <Card.Body className="bg-light" variant="info">
                <Row>
                  <Col sm={8}>
                    <Col>
                      <Card.Title>
                        <h5>
                          <i className="fas fa-bullhorn text-right mr-2  text-info"></i>{" "}
                          <strong>{post.job_title} </strong>
                          <span className="badge bg-info text-white">
                            {" "}
                            {post.rent} € /Month
                          </span>
                        </h5>
                      </Card.Title>
                    </Col>
                    <Col>
                      <Card.Text>
                        <i className="fas fa-home text-right mr-2  text-info"></i>
                        {post.text}
                      </Card.Text>
                      <p className="text-info  ">
                        <small>
                          <em>
                            <Moment fromNow>{post.date}</Moment>{" "}
                          </em>
                        </small>
                      </p>
                    </Col>
                  </Col>

                  <Col sm={4} style={{ justifyContent: "flex-end" }}>
                    <Col>
                      <p className=" text-right ">
                        <Badge variant="info">Neigbourhoods</Badge> {post.level}
                      </p>
                    </Col>
                    <Col>
                      <p className="text-right ml-2">
                        <Badge variant="info">Domiciliation</Badge>{" "}
                        {post.remote}
                      </p>
                    </Col>
                    <Col>
                      <p className="text-right ml-2">
                        <Badge variant="info">Location </Badge>{" "}
                        {post.location_city},
                        <strong>{post.location_country} </strong>
                      </p>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={8}>
                    <p onClick={this.onViewClick.bind(this, post._id)}>
                      {isEmpty(post.link) ? null : (
                        <a
                          className="lead "
                          href={`https://spotahome.sjv.io/c/2913702/870243/12133?url=${post.link}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {/* <i className="bi bi-eye-fill"></i>*/}
                          <i
                            className={classnames("bi bi-eye-fill", {
                              "text-info": this.findUserView(post.views),
                            })}
                          ></i>
                          Check
                        </a>
                      )}
                      <br />
                      <Badge className="badge text-info">
                        {post.views.length}
                      </Badge>
                      {post.views.length === undefined ||
                      post.views.length === 0 ? (
                        <small>View</small>
                      ) : (
                        <small>Views</small>
                      )}
                    </p>
                  </Col>
                  <Col xs={6} md={4}>
                    <div
                      style={{
                        justifyContent: "flex-end",
                        paddingLeft: "2px",
                        margingLeft: "2px",
                      }}
                      className="text-right d-flex flex-row mr-lg-0 pr-lg-0"
                    >
                      {showActions ? (
                        <span className="text-right">
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <button
                              onClick={this.onLikeClick.bind(this, post._id)}
                              type="button"
                              className="btn btn-light mr-1"
                            >
                              <i
                                className={classnames("fas fa-thumbs-up", {
                                  "text-info": this.findUserLike(post.likes),
                                })}
                              />
                              <span className="badge badge-light">
                                {post.likes.length}
                              </span>
                            </button>
                            <button
                              onClick={this.onUnlikeClick.bind(this, post._id)}
                              type="button"
                              className="btn btn-light mr-1"
                            >
                              <i className="text-secondary fas fa-thumbs-down" />
                            </button>

                            <Link
                              to={`/post/${post._id}`}
                              className="btn Close-up-Of-A-Dog-With-Toy-1-hex mr-1"
                            >
                              <i className="bi bi-chat-square-dots-fill"></i>
                            </Link>
                            {post.user === auth.user.id ? (
                              <button
                                onClick={this.onDeleteClick.bind(
                                  this,
                                  post._id
                                )}
                                type="button"
                                className="btn btn-danger text-right"
                              >
                                <i className="fas fa-times text-right" />
                              </button>
                            ) : null}
                          </div>
                        </span>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

PostItem.defaultProps = {
  showActions: true,
};

PostItem.propTypes = {
  deletePost: PropTypes.func.isRequired,
  addLike: PropTypes.func.isRequired,
  addView: PropTypes.func.isRequired,
  removeLike: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  deletePost,
  addLike,
  addView,
  removeLike,
})(PostItem);
